import { StyleSheet } from 'aphrodite';
import { titles, lightGray, borderColor, label, midGrey, destructive } from '../../../styles/colors';

export const ContentWidth = 450;
export const PreviewHeight = 200;

export const styleSheet = StyleSheet.create({
	container: {
		minHeight: 300,
		width: ContentWidth,
	},
	header: {
		alignItems: 'center',
		backgroundColor: lightGray,
		borderBottom: `1px solid ${borderColor}`,
		color: titles,
		display: 'flex',
		fontSize: 18,
		fontWeight: 'bold',
		justifyContent: 'space-between',
		padding: 16,
	},
	search: {
		color: label,
		fontSize: 14,
		minHeight: 150,
		padding: 16,
		position: 'relative',
	},
	preview: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		marginTop: 16,
	},
	thumbnailPreview: {
		border: `1px solid ${borderColor}`,
		borderRadius: 4,
		maxHeight: PreviewHeight,
		maxWidth: '100%',
	},
	videoTitle: {
		color: midGrey,
		fontSize: 12,
		marginTop: 8,
		textAlign: 'center',
	},
	error: {
		color: destructive,
		fontSize: 12,
		marginTop: 8,
	},
	footer: {
		borderTop: `1px solid ${borderColor}`,
		justifyContent: 'flex-end',
		marginTop: 30,
		padding: 16,
	},
});
